import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=63d8c2c8&scoped=true"
import script from "./Download.vue?vue&type=script&lang=ts"
export * from "./Download.vue?vue&type=script&lang=ts"
import style0 from "./download.css?vue&type=style&index=0&id=63d8c2c8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d8c2c8",
  null
  
)

export default component.exports